module.exports = __webpack_public_path__ + "static/media/movi-rate.09f1c419.jpg";